export const inputsBlocksObj = {
  1: {
    id: '1',
    title: '',
    isFold: false,
    inputsName: ['api', 'secretKey'],
  },
  headers: {
    id: 'headers',
    title: 'Headers',
    isFold: false,
    inputsName: ['contenttype', 'accept'],
  },
  params: {
    id: 'params',
    title: 'Parameters',
    isFold: true,
    // inputsName: ['clientId','userId', 'nick', 'password','authType','sessionId','lang', 'launchOptions', 'currency', 'bonusCode', 'email', 'phoneNumber', 'redeemCode', 'country', 'referralCode', 'userIp', 'gameCode', 'gameId'],
    inputsName: ['clientId', 'userId', 'sessionId', 'nick', 'password', 'authType', 'gameCode',
                 'tableId', 'gameId', 'lang', 'launchOptions', 'currency', 'bonusCode', 'email', 'phoneNumber',
                 'redeemCode', 'active', 'verified', 'country', 'referralCode', 'tag', 'avatar', 'userIp',
                  'longLifeLoginToken', 'avatarId', 'trustedLevel'],

  }
}
